import { render, staticRenderFns } from "./add-org.vue?vue&type=template&id=2b336f63&scoped=true"
import script from "./add-org.vue?vue&type=script&lang=js"
export * from "./add-org.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b336f63",
  null
  
)

export default component.exports